<template>
  <div class="infomation">
    <el-main v-if="isPc">
      <el-tabs v-model="active" tab-position="left" @tab-click="handleClick">
        <el-tab-pane
          :label="item.type_name"
          :name="index + ''"
          v-for="(item, index) in rowMenuList"
          :key="index"
        >
          <article-list :article_type="item.type_id"></article-list>
        </el-tab-pane>
        <el-tab-pane label="大事记" name="5">
          <div class="events" v-for="(item,index) in eventsArr" :key="item.id">
            <div class="title justify-between align-center">
              <h3>{{ item.title }}</h3>
              <div class="time little_hand">
                发布于{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}
              </div>
            </div>
            <p class="desc">{{ item.desctext }}</p>
            <swiper :id="item.id" />
            <div class="more little_hand" @click="fnToEvents(item.id, index)">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <div v-else>
      <el-tabs
        class="m-tabs"
        v-model="active"
        tab-position="top"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :label="item.type_name"
          :name="index + ''"
          v-for="(item, index) in rowMenuList"
          :key="index"
        >
          <article-list :article_type="item.type_id"></article-list>
        </el-tab-pane>
        <el-tab-pane label="大事记" name="5">
          <div
            class="events"
            v-for="(item, index) in eventsArr"
            :key="item.id"
            @click="fnToEvents(item.id, index)"
          >
            <div class="title justify-between align-center">
              <h3>{{ item.title }}</h3>
              <div class="time little_hand">
                发布于{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}
              </div>
            </div>
            <p class="desc">{{ item.desctext }}</p>
            <swiper :id="item.id" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import articleList from "./article-list";
import swiper from "./common/swiper.vue";
export default {
  components: {
    articleList,
    swiper,
  },
  data() {
    return {
      eventsArr: [],
      active: "0",
    };
  },
  computed: {
    ...mapState(["rowMenuList", "isPc"]),
  },
  methods: {
    handleClick(tab, event) {
      this.active = tab.index;
      // this.$route.params.active=tab.index
      this.$router.push({
        path: `/information/${tab.index}`,
      });
      // console.log(this.$route)
      // this.article_type=this.rowMenuList[tab.index].type_id
    },
    // 获取大事记列表
    async getEvents() {
      const { data: res } = await this.$http.get(
        `/api/v2/article/timeMemoryList/SZTX`
      );
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.eventsArr = res.data;
    },
    fnToEvents(id, index) {
      window.sessionStorage.setItem("title", this.eventsArr[index].title);
      this.$router.push({
        path: `/events/${id}`,
      });
    },
  },
  watch: {
    $route(to, from) {
      // console.log(this.$$route)
      // console.log(to)
      // console.log(from)
      this.active = to.params.active;
    },
  },
  created() {
    // console.log(this.$route)
    this.active = this.$route.params.active;
    this.getEvents();
  },
};
</script>

<style lang="less" scoped>
.infomation {
  background: #f2f2f2;
}
.el-main {
  width: 1200px;
  padding-top: 50px;
  margin-bottom: 0;
  padding-bottom: 50px;
}
.events {
  position: relative;
  padding: 20px 0;
  background: #2c2d33;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  .more {
    opacity: 0.5;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 400;
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: end;
    margin-top: 20px;
    margin-right: 20px;
  }
  .bg {
    position: absolute;
    right: 0;
    top: 0;
    img {
      width: auto;
      height: 100%;
    }

    height: 100%;
  }
  .bg::before {
    position: absolute;
    right: 0;
    top: 0;
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      270deg,
      rgba(44, 45, 51, 0) 19%,
      #2c2d33 97%
    );
  }
  .title {
    margin-bottom: 5px;
    padding: 0 20px;
    position: relative;
    z-index: 99;
    h3 {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
      display: flex;
      align-items: center;
    }
    h3::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 20px;
      opacity: 0.4;
      background: #ffffff;
      transform: rotate(15deg);
      margin-right: 10px;
    }
    .time {
      opacity: 0.5;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
      position: relative;
      z-index: 99;
    }
  }
  .desc {
    opacity: 0.5;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: justify;
    line-height: 20px;
    font-weight: 400;
    padding-left: 20px;
    position: relative;
    z-index: 99;
  }
  .events-swiper {
    margin-top: 20px;
    .events-swiper-item {
      width: 100%;
      height: 200px;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      h3 {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 15px;
        width: 100%;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        opacity: 0.7;
        background: rgba(0, 0, 0, 0.7);
        box-sizing: border-box;
        // border-radius: 0px 0px 4px 4px;
      }
    }
    .time {
      display: flex;
      align-items: center;
      margin-top: 10px;
      .circle {
        width: 6px;
        height: 6px;
        border: 3px solid rgba(255, 255, 255, 1);
        border-radius: 12px;
      }
      time {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: justify;
        line-height: 20px;
        font-weight: 400;
        margin-left: 5px;
        margin-right: 10px;
      }
      .line {
        flex: 1;
        border-top: 2px dashed rgba(255, 255, 255, 0.24);
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .events {
    position: relative;
    padding: 16px 0;
    background: #2c2d33;
    border-radius: 8px;
    margin: 0 16px 16px;
    overflow: hidden;
    height: 200px;
    .bg {
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: auto;
        height: 100%;
        object-fit: cover;
      }

      height: 100%;
    }
    .bg::before {
      position: absolute;
      right: 0;
      top: 0;
      content: "";
      display: inline-block;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
        270deg,
        rgba(44, 45, 51, 0) 19%,
        #2c2d33 97%
      );
    }
    .title {
      margin-bottom: 5px;
      padding: 0 16px;
      h3 {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        display: flex;
        align-items: center;
      }
      h3::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 16px;
        opacity: 0.4;
        background: #ffffff;
        transform: rotate(15deg);
        margin-right: 6px;
      }
      .time {
        opacity: 0.5;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 400;
        position: relative;
        z-index: 99;
      }
    }
    .desc {
      opacity: 0.5;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 20px;
      font-weight: 400;
      padding-left: 20px;
    }
    .events-swiper {
      margin-top: 16px;
      .events-swiper-item {
        width: 100%;
        height: 160px;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        h3 {
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 12px;
          width: 100%;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 400;
          opacity: 0.7;
          background: rgba(0, 0, 0, 0.7);
          box-sizing: border-box;
          // border-radius: 0px 0px 4px 4px;
        }
      }
      .time {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .circle {
          width: 6px;
          height: 6px;
          border: 3px solid rgba(255, 255, 255, 1);
          border-radius: 12px;
        }
        time {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: justify;
          line-height: 20px;
          font-weight: 400;
          margin-left: 5px;
          margin-right: 10px;
        }
        .line {
          flex: 1;
          border-top: 2px dashed rgba(255, 255, 255, 0.24);
        }
      }
    }
  }
}
/deep/.el-tabs__header {
  width: 140px;
  background-color: rgb(255, 255, 255);
  margin-right: 32px !important;
  border-radius: 4px;
  overflow: hidden;
  .el-tabs__nav-wrap::after {
    content: none;
  }
  .el-tabs__item {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #222222;
    font-weight: 400;
    // padding: 8px;
    height: 40px;
    line-height: 40px;
    text-align: center !important;
  }
  .el-tabs__item.is-active {
    color: #ffffff;
    background: #20317f;
  }
  .el-tabs__item:hover {
    color: #20317f !important;
  }
  .el-tabs__item.is-active {
    color: #ffffff !important;
  }
  .el-tabs__active-bar {
    background-color: #20317f;
  }
}
.el-button {
  width: 100%;
  font-size: 14px;
  color: #878787;
  line-height: 22px;
  padding: 10px 0;
  background: #fbfbfb;
  border: none;
}
.news_item {
  padding: 15px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  .el-image {
    width: 200px;
    height: 120px;
    margin-right: 26px;
  }
  .news_item_info {
    // margin-top: 8px;
    flex: 1;
    h3 {
      font-size: 22px;
      line-height: 34px;
      color: #000;
      margin-bottom: 18px;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
  }
}
</style>
<style lang="less">
.m-tabs {
  background: #fff;
}
.infomation .m-tabs .el-tabs__header {
  width: 100%;

  span {
    display: none;
  }
  .el-tabs__item {
    padding: 0 10px !important;
  }
  .el-tabs__item.is-active {
    color: #4f4e95 !important;
    background: none;
  }
}
.infomation .m-tabs .el-tabs__nav {
  float: none !important;
  overflow: scroll !important;
}
.infomation .m-tabs .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}
</style>